import Vue from "vue";
import { ActionTree, MutationTree, GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { ServerResult } from "@/core/http/server_result";
import cloneDeep from "lodash/cloneDeep";
import { saveAs } from "file-saver";
import { fetchEnumsFromSchema } from "@/core/tools/forms/fetch_enums_from_schema";
import moment from "moment";
import { group } from "console";

interface ShiftAtomLaboratoryState {
  loaded: boolean;
  loading: boolean;
  fatalError: boolean;

  documentId: any;
  clientId: any;
  meta: any;
  schema: any;

  // productList: any[];
  // productVariantList: any[];
  prefereds: any;
  relatedFactsList: any[];

  targetForDelete: any[];
  // inWorkStatus: any;
  // formationStatus: any;
  // products: any[];
  remains: any[];
}

const state: ShiftAtomLaboratoryState = {
  loading: false,
  loaded: false,
  fatalError: false,

  documentId: null,
  clientId: null,
  meta: null,
  schema: null,

  // productList: [],
  // productVariantList: [],
  prefereds: [],
  relatedFactsList: [],

  targetForDelete: [],
  // products: [],
  remains: [],
};

const initState: any = cloneDeep(state);

const GET_SHIFT_CLOTS_VDP = "GET_SHIFT_CLOTS_VDP";
const SHIFT_CLOTS_SCHEMA = "GET_SHIFT_CLOTS_SCHEMA";

export const actions: ActionTree<ShiftAtomLaboratoryState, RootState> = {
  reset({ commit }) {
    commit("RESET_STATE");
  },

  loadData(
    { commit, getters, dispatch, state },
    { documentId, clientId, remains },
  ) {
    const vm = (this as any)._vm;
    commit("START_LOADING");

    state.documentId = documentId;
    state.clientId = clientId;
    state.remains = remains;

    return new Promise((resolve, reject) => {
      vm.$db([
        vm
          .$q(GET_SHIFT_CLOTS_VDP)
          .raw("documents.list")
          .action({
            columns: {
              id: "sal.id",
              plan_number: "sacp.number",
              plan_number2: "sa.number",
              datetime: "sal.datetime",
              release_datetime: "sal.release_datetime",
              base_name: "sacpi.name",
              product_name: "p.name",
              produced_product_name: "pp.name",
              journal_acidity_4: "sja.acidity_4",
              acidity_4: "sacpm.acidity_4",
              target_acidity: "pp.target_acidity",
              fact_datetime: "sja.bottling_end_date",
              border_creaminess_longitude: "pp.creaminess_longitude",
              border_creaminess_height: "pp.creaminess_height",
              density_vpr: "sal.density_vpr",
              speed_vpr: "sal.speed_vpr",
              viscosity_vpr: "sal.viscosity_vpr",
              resistance_vpr: "sal.resistance_vpr",
              temp_vpr: "sal.temp_vpr",
              acidity_ohaus_vpr: "sal.acidity_ohaus_vpr",
              acidity_mettler_vpr: "sal.acidity_mettler_vpr",
              density_gph: "sal.density_gph",
              speed_gph: "sal.speed_gph",
              viscosity_gph: "sal.viscosity_gph",
              resistance_gph: "sal.resistance_gph",
              temp_gph: "sal.temp_gph",
              stirability_thermomix_name: "voc_stirability_thermomix.name",
              stirability_thermomix_color: "voc_stirability_thermomix.color",
              stirability_thermomix_quarantine:
                "voc_stirability_thermomix.quarantine",
              stirability_thermomix_recycling:
                "voc_stirability_thermomix.recycling",
              glitter_thermomix_name: "voc_glitter_thermomix.name",
              glitter_thermomix_color: "voc_glitter_thermomix.color",
              glitter_thermomix_quarantine: "voc_glitter_thermomix.quarantine",
              glitter_thermomix_recycling: "voc_glitter_thermomix.recycling",
              thermal_stability_name: "voc_thermal_stability.name",
              thermal_stability_color: "voc_thermal_stability.color",
              thermal_stability_quarantine: "voc_thermal_stability.quarantine",
              thermal_stability_recycling: "voc_thermal_stability.recycling",
              heat_resistance_name: "voc_heat_resistance.name",
              heat_resistance_color: "voc_heat_resistance.color",
              heat_resistance_quarantine: "voc_heat_resistance.quarantine",
              heat_resistance_recycling: "voc_heat_resistance.recycling",
              hardness_name: "voc_hardness.name",
              hardness_color: "voc_hardness.color",
              hardness_quarantine: "voc_hardness.quarantine",
              hardness_recycling: "voc_hardness.recycling",
              causticity_initial_spalling_name:
                "voc_causticity_initial_spalling.name",
              causticity_initial_spalling_color:
                "voc_causticity_initial_spalling.color",
              causticity_initial_spalling_quarantine:
                "voc_causticity_initial_spalling.quarantine",
              causticity_initial_spalling_recycling:
                "voc_causticity_initial_spalling.recycling",
              plasticity_name: "voc_plasticity.name",
              plasticity_color: "voc_plasticity.color",
              plasticity_quarantine: "voc_plasticity.quarantine",
              plasticity_recycling: "voc_plasticity.recycling",
              looseness_name: "voc_looseness.name",
              looseness_color: "voc_looseness.color",
              looseness_quarantine: "voc_looseness.quarantine",
              looseness_recycling: "voc_looseness.recycling",
              sound_product_breaking_name: "voc_sound_product_breaking.name",
              sound_product_breaking_color: "voc_sound_product_breaking.color",
              sound_product_breaking_quarantine:
                "voc_sound_product_breaking.quarantine",
              sound_product_breaking_recycling:
                "voc_sound_product_breaking.recycling",
              sound_product_released_name: "voc_sound_product_released.name",
              sound_product_released_color: "voc_sound_product_released.color",
              sound_product_released_quarantine:
                "voc_sound_product_released.quarantine",
              sound_product_released_recycling:
                "voc_sound_product_released.recycling",
              feeling_of_texture_name: "voc_feeling_of_texture.name",
              feeling_of_texture_color: "voc_feeling_of_texture.color",
              feeling_of_texture_quarantine:
                "voc_feeling_of_texture.quarantine",
              feeling_of_texture_recycling: "voc_feeling_of_texture.recycling",
              fluff_effect_name: "voc_fluff_effect.name",
              fluff_effect_color: "voc_fluff_effect.color",
              fluff_effect_quarantine: "voc_fluff_effect.quarantine",
              fluff_effect_recycling: "voc_fluff_effect.recycling",
              creaminess_longitude: "sal.creaminess_longitude",
              creaminess_height: "sal.creaminess_height",
              kislinka_name: "voc_kislinka.name",
              kislinka_color: "voc_kislinka.color",
              kislinka_quarantine: "voc_kislinka.quarantine",
              kislinka_recycling: "voc_kislinka.recycling",
              serbian_profile_name: "voc_serbian_profile.name",
              serbian_profile_color: "voc_serbian_profile.color",
              serbian_profile_quarantine: "voc_serbian_profile.quarantine",
              serbian_profile_recycling: "voc_serbian_profile.recycling",
              sweetness_name: "voc_sweetness.name",
              sweetness_color: "voc_sweetness.color",
              sweetness_quarantine: "voc_sweetness.quarantine",
              sweetness_recycling: "voc_sweetness.recycling",
              salinity_name: "voc_salinity.name",
              salinity_color: "voc_salinity.color",
              salinity_quarantine: "voc_salinity.quarantine",
              salinity_recycling: "voc_salinity.recycling",
              vices_name: "voc_vices.name",
              vices_color: "voc_vices.color",
              vices_quarantine: "voc_vices.quarantine",
              vices_recycling: "voc_vices.recycling",
            },
            from: "s:shift_atom_laboratory",
            from_as: "sal",
            joins: [
              {
                join: "s:shift_atom_coock_plan",
                type: "left",
                as: "sacp",
                on: {
                  $eq: ["sacp.id", "sal.plan_id"],
                },
              },
              {
                join: {
                  columns: {
                    coock_plan_id: "sacpi.coock_plan_id",
                    name: { $array_agg: "vb.name" },
                  },
                  from: "s:shift_atom_coock_plan_items",
                  from_as: "sacpi",
                  joins: [
                    {
                      join: "s:voc_bases",
                      type: "left",
                      as: "vb",
                      on: {
                        $eq: ["vb.id", "sacpi.base_id"],
                      },
                    },
                  ],
                  groups: ["sacpi.coock_plan_id"],
                },
                type: "left",
                as: "sacpi",
                on: { $eq: ["sacp.id", "sacpi.coock_plan_id"] },
              },
              {
                join: "s:shift_atom",
                type: "left",
                as: "sa",
                on: {
                  $eq: ["sal.bottling_plan_id", "sa.id"],
                },
              },
              {
                join: "s:products",
                type: "left",
                as: "p",
                on: {
                  $eq: ["sa.product_id", "p.id"],
                },
              },
              {
                join: "s:produced_products",
                type: "left",
                as: "pp",
                on: {
                  $eq: ["pp.id", "sacp.product_id"],
                },
              },
              {
                join: "s:shift_journal_atom",
                type: "left",
                as: "sja",
                on: {
                  $eq: ["sja.plan_id", "sacp.id"],
                },
              },
              {
                join: "s:shift_atom_coock_plan_marks",
                type: "left",
                as: "sacpm",
                on: {
                  $eq: ["sacpm.plan_id", "sacp.id"],
                },
              },
              {
                join: "s:voc_stirability_thermomix",
                type: "left",
                as: "voc_stirability_thermomix",
                on: {
                  $eq: [
                    "sal.stirability_thermomix_id",
                    "voc_stirability_thermomix.id",
                  ],
                },
              },
              {
                join: "s:voc_glitter_thermomix",
                type: "left",
                as: "voc_glitter_thermomix",
                on: {
                  $eq: ["sal.glitter_thermomix_id", "voc_glitter_thermomix.id"],
                },
              },
              {
                join: "s:voc_thermal_stability",
                type: "left",
                as: "voc_thermal_stability",
                on: {
                  $eq: ["sal.thermal_stability_id", "voc_thermal_stability.id"],
                },
              },
              {
                join: "s:voc_heat_resistance",
                type: "left",
                as: "voc_heat_resistance",
                on: {
                  $eq: ["sal.heat_resistance_id", "voc_heat_resistance.id"],
                },
              },
              {
                join: "s:voc_hardness",
                type: "left",
                as: "voc_hardness",
                on: {
                  $eq: ["sal.hardness_id", "voc_hardness.id"],
                },
              },
              {
                join: "s:voc_causticity_initial_spalling",
                type: "left",
                as: "voc_causticity_initial_spalling",
                on: {
                  $eq: [
                    "sal.causticity_initial_spalling_id",
                    "voc_causticity_initial_spalling.id",
                  ],
                },
              },
              {
                join: "s:voc_plasticity",
                type: "left",
                as: "voc_plasticity",
                on: {
                  $eq: ["sal.plasticity_id", "voc_plasticity.id"],
                },
              },
              {
                join: "s:voc_looseness",
                type: "left",
                as: "voc_looseness",
                on: {
                  $eq: ["sal.looseness_id", "voc_looseness.id"],
                },
              },
              {
                join: "s:voc_sound_product_breaking",
                type: "left",
                as: "voc_sound_product_breaking",
                on: {
                  $eq: [
                    "sal.sound_product_breaking_id",
                    "voc_sound_product_breaking.id",
                  ],
                },
              },
              {
                join: "s:voc_sound_product_released",
                type: "left",
                as: "voc_sound_product_released",
                on: {
                  $eq: [
                    "sal.sound_product_released_id",
                    "voc_sound_product_released.id",
                  ],
                },
              },
              {
                join: "s:voc_feeling_of_texture",
                type: "left",
                as: "voc_feeling_of_texture",
                on: {
                  $eq: [
                    "sal.feeling_of_texture_id",
                    "voc_feeling_of_texture.id",
                  ],
                },
              },
              {
                join: "s:voc_fluff_effect",
                type: "left",
                as: "voc_fluff_effect",
                on: {
                  $eq: ["sal.fluff_effect_id", "voc_fluff_effect.id"],
                },
              },
              {
                join: "s:voc_kislinka",
                type: "left",
                as: "voc_kislinka",
                on: {
                  $eq: ["sal.kislinka_id", "voc_kislinka.id"],
                },
              },
              {
                join: "s:voc_serbian_profile",
                type: "left",
                as: "voc_serbian_profile",
                on: {
                  $eq: ["sal.serbian_profile_id", "voc_serbian_profile.id"],
                },
              },
              {
                join: "s:voc_sweetness",
                type: "left",
                as: "voc_sweetness",
                on: {
                  $eq: ["sal.sweetness_id", "voc_sweetness.id"],
                },
              },
              {
                join: "s:voc_salinity",
                type: "left",
                as: "voc_salinity",
                on: {
                  $eq: ["sal.salinity_id", "voc_salinity.id"],
                },
              },
              {
                join: "s:voc_vices",
                type: "left",
                as: "voc_vices",
                on: {
                  $eq: ["sal.vices_id", "voc_vices.id"],
                },
              },
            ],
            page_size: 1000,
            page: 1,
            order: [{ $desc: ["sal.datetime"] }, { $desc: ["sal.id"] }],
            where: {
              $or: [{ $eq: [`sacp.shift_id`, { $: documentId }] }],
            },
          }),
        vm
          .$q(SHIFT_CLOTS_SCHEMA)
          .raw("schemas.get")
          .action({
            id: `s:shift_atom_laboratory`,
          }),
      ]).then((result: ServerResult) => {
        commit("LOADED_SUCCESS");
        const opRelResult = result.getOperation(GET_SHIFT_CLOTS_VDP);
        if (!opRelResult.hasError()) {
          state.relatedFactsList = opRelResult
            .getContent()
            .documents.map((item: any) => {
              item.base_name = item.base_name
                ? item.base_name.filter(
                    (value: any, index: any, array: any) => {
                      return array.indexOf(value) === index;
                    },
                  )
                : "";
              return item;
            });
        }

        const opRelSchema = result.getOperation(SHIFT_CLOTS_SCHEMA);
        if (!opRelSchema.hasError()) {
          state.schema = opRelSchema.getContent().schema;
          state.meta = fetchEnumsFromSchema(state.schema);
        }

        resolve(null);
      });
    });
  },

  exportAsXLSX({ rootState, state }, { documentId }) {
    const vm = (this as any)._vm;

    return new Promise((resolve, reject) => {
      vm.$db([
        vm
          .$q("EXPORT")
          .raw("documents.report")
          .action({
            template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>Время измерения</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Момент истины</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Термокамера</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Расположение паллета</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ партии</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Наименование базы</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ ряда</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>№ ведра</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>t °С</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>рН теплого сгустка</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Степень упругости</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Глубина колкости от поверхности ведра</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Характеристика сгустка, если не колкий</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Уровень качества</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Инцидент</td>
</tr>
{{#clots.documents}}
  <tr height="auto">
    <td wrap border type="date" date-format="DD.MM.YYYY HH:mm">{{datetime}}</td>
    <td wrap border >{{moment}}</td>
    <td wrap border >{{termocamera}}</td>
    <td wrap border >{{direct}}</td>
    <td wrap border >{{plan_number}}</td>
    <td wrap border base>{{base_name}}</td>
    <td wrap border >{{row_number}}</td>
    <td wrap border >{{bucket_number}}</td>
    <td wrap border >{{temp}}</td>
    <td wrap border >{{acidity}}</td>
    <td wrap border >{{elasticity_name}}</td>
    <td wrap border >{{causticity_name}}</td>
    <td wrap border >{{characteristic}}</td>
    <td wrap border >-</td>
    <td wrap border >{{incident_type_name}} / {{incident_sub_type_name}}</td>
  </tr>
{{/clots.documents}}
</table>
                `,
            queries: {
              clots: {
                columns: {
                  id: "scv.id",
                  datetime: "scv.datetime",
                  plan_number: "spv.number",
                  shift_date: "s.shift_date",
                  moment: "scv.moment",
                  termocamera: "scv.termocamera",
                  direct: "scv.direct",
                  row_number: "scv.row_number",
                  base_name: { $concat: ["b.name", { $: " " }, "vst.name"] },
                  bucket_number: "scv.bucket_number",
                  temp: "scv.temp",
                  acidity: "scv.acidity",
                  elasticity_name: "ve.name",
                  causticity_name: "vc.name",
                  characteristic: "scv.characteristic",
                  incident_sub_type_name: "ist.name",
                  incident_type_name: "it.name",
                },
                from: "s:shift_clot_vdp",
                from_as: "scv",
                joins: [
                  {
                    join: "s:shifts",
                    type: "left",
                    as: "s",
                    on: {
                      $eq: ["s.id", "scv.shift_id"],
                    },
                  },
                  {
                    join: "s:shift_plan_vdp",
                    type: "left",
                    as: "spv",
                    on: {
                      $eq: ["spv.id", "scv.plan_id"],
                    },
                  },
                  {
                    join: "s:voc_bases",
                    type: "left",
                    as: "b",
                    on: {
                      $eq: ["b.id", "spv.base_id"],
                    },
                  },
                  {
                    join: "s:voc_starter_types",
                    type: "left",
                    as: "vst",
                    on: {
                      $eq: ["vst.id", "spv.starter_type_id"],
                    },
                  },
                  {
                    join: "s:voc_elasticities",
                    type: "left",
                    as: "ve",
                    on: {
                      $eq: ["ve.id", "scv.elasticity_id"],
                    },
                  },
                  {
                    join: "s:voc_causticities",
                    type: "left",
                    as: "vc",
                    on: {
                      $eq: ["vc.id", "scv.causticity_id"],
                    },
                  },
                  {
                    join: "s:incident_sub_types",
                    type: "left",
                    as: "ist",
                    on: {
                      $eq: ["ist.id", "scv.incident_sub_type_id"],
                    },
                  },
                  {
                    join: "s:incident_types",
                    type: "left",
                    as: "it",
                    on: {
                      $eq: ["it.id", "ist.incident_type_id"],
                    },
                  },
                ],
                order: [{ $asc: ["scv.id"] }],
                where: {
                  $or: [
                    { $eq: [`scv.shift_id`, { $: documentId }] },
                    { $eq: [`scv.shift_id`, { $: documentId }] },
                  ],
                },
              },
            },
            format: "xlsx",
          }),
      ]).then((result: ServerResult) => {
        const exportOpContent = result.getOperation("EXPORT").getContent();
        const fToken = exportOpContent.token;
        const aToken = (rootState as any).ubic.token;
        const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
        saveAs(fileUrl, "export.xlsx");

        resolve();
      });
    });
  },
};

export const mutations: MutationTree<ShiftAtomLaboratoryState> = {
  RESET_STATE: (state) => {
    for (const key in initState) {
      (state as any)[key] = initState[key];
    }
  },
  START_LOADING: (state) => {
    state.loaded = false;
    state.loading = true;
    state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
    state.loaded = true;
    state.loading = false;
    state.fatalError = true;
  },

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftAtomLaboratoryState, RootState> = {
  totals: (state: ShiftAtomLaboratoryState) => {
    return {
      sum: state.relatedFactsList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0);
      }, 0),
    };
  },
  finalRelatedFactsList: (state: ShiftAtomLaboratoryState) => {
    return Object.values(
      state.relatedFactsList.reduce((prev: any, item: any) => {
        if (
          !prev[item.plan_number] ||
          item.direct == "up" ||
          prev[item.plan_number].direct == "down"
        ) {
          prev[item.plan_number] = item;
        }
        return prev;
      }, {}),
    );
  },
  groupByPlan: (state: ShiftAtomLaboratoryState) => {
    const evenDatetime = state.relatedFactsList.reduce(
      (prev: any, item: any) => {
        if (!prev[item.plan_number]) {
          prev[item.plan_number] = [];
        }
        if (!prev[item.plan_number].includes(item.datetime || "-")) {
          prev[item.plan_number].push(item.datetime || "-");
        }
        return prev;
      },
      {},
    );
    let i = 0;
    return Object.values(
      state.relatedFactsList.reduce((prev: any, item: any) => {
        if (!prev[item.plan_number]) {
          prev[item.plan_number] = {
            plan_number: item.plan_number,
            base_name: item.base_name,
            class_row:
              evenDatetime[item.plan_number].indexOf(item.datetime || "-") %
                2 !==
              0
                ? "is-even-datetime"
                : "",
            laboratory: {
              class_row: [],
              rows: [],
            },
          };
        }
        const _keys_quarantine: any[] = [];
        const _keys_recycling: any[] = [];
        Object.keys(item).map((key: string) => {
          if (key.includes("_quarantine")) {
            _keys_quarantine.push(key);
          }
          if (key.includes("_recycling")) {
            _keys_recycling.push(key);
          }
          if (!prev[item.plan_number].laboratory[key]) {
            prev[item.plan_number].laboratory[key] = [];
          }
          prev[item.plan_number].laboratory[key].push(item[key]);
        });
        prev[item.plan_number].laboratory.rows.push(item);
        prev[item.plan_number].laboratory.class_row.push(
          evenDatetime[item.plan_number].indexOf(item.datetime) % 2 !== 0
            ? "is-even-datetime"
            : "",
        );

        const _quarantine = _keys_quarantine.reduce(
          (accum: boolean, key: any) => {
            // @ts-ignore
            return (
              accum || (prev[item.plan_number].laboratory[key][i] as boolean)
            );
          },
          false,
        );
        const _recycling = _keys_recycling.reduce(
          (accum: boolean, key: any) => {
            // @ts-ignore
            return (
              accum || (prev[item.plan_number].laboratory[key][i] as boolean)
            );
          },
          false,
        );

        console.log("_quarantine", _quarantine);
        console.log("_recycling", _recycling);

        i += 1;
        return prev;
      }, {}),
    ).sort((a: any, b: any) => {
      const keyA = parseFloat(a.plan_number);
      const keyB = parseFloat(b.plan_number);
      const result = keyA > keyB ? 1 : keyA < keyB ? -1 : 0;
      return result;
    });
  },
};

export const STORE_KEY = "$_shift_atom_laboratory_list";

export const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
